export default __webpack_public_path__ + "static/cruiselines-vv-ship-3-367e8bae313f81eefcb8c1f8e48f0070.jpg";